export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  requestTimeoutMs: 10_000
} as const;
